import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { FormattedMessage, FormattedNumber, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import * as ApiActions from 'actions/api';
import Layout from 'components/Layout';
import ShareKit from 'components/ShareKit';
import SimpleText from 'components/SimpleText';
import * as OfferSelectors from 'selectors/offer';
import Gallery from '../components/Gallery';
import Sponsor from '../components/Sponsor';
import '../styles/offer.scss';
const mapStateToProps = OfferSelectors.offerStructuredSelector;
const messages = defineMessages({
    price: '{price, number, amount_nomin} SWC',
    left: '{quantity} left',
    donation: 'CHARITY',
    redemption: 'Redemption process',
    details: 'Offer details',
});
class Offer extends Component {
    static fetchData({ match }, store) {
        return store.dispatch(ApiActions.prefetchOffer(match.params.offer_id));
    }
    render() {
        const meta = [
            { name: 'description', content: this.props.meta.description },
            { property: 'og:title', content: this.props.meta.title },
            { property: 'og:description', content: this.props.meta.description },
            { property: 'og:image', content: this.props.meta.image },
            { name: 'twitter:title', content: this.props.meta.title },
            { name: 'twitter:description', content: this.props.meta.description },
            { name: 'twitter:image', content: this.props.meta.image },
            { name: 'event-id', content: 'offer' },
            { name: 'event-params', content: { offer_id: this.props.model.id } },
            {
                name: 'apple-itunes-app',
                content: 'app-id=971023427',
            },
        ];
        if (this.props.model.disallow_search_engines) {
            meta.push({ name: 'robots', content: 'noindex' });
        }
        return (_jsxs(Layout, { headerOptions: { lightMobile: true }, children: [_jsx(Helmet, { title: this.props.meta.title, link: [{ rel: 'image_src', href: this.props.meta.image }], meta: meta }), _jsxs("section", { className: "offer", children: [_jsx(Gallery, { models: this.props.model.images }), _jsxs(Layout.Container, { children: [_jsxs("div", { className: "offer__header", children: [_jsx("div", { className: "offer__share only-desktop", children: _jsx(ShareKit, {}) }), _jsxs("div", { className: "offer__info", children: [this._renderTitle(), this._renderPrice()] }), _jsx("div", { className: "offer__share only-mobile", children: _jsx(ShareKit, {}) })] }), _jsx("div", { className: "offer__description", children: _jsx(SimpleText, { content: this.props.model.description }) }), this._renderBullets(), this._renderBrand(), this._renderCharity(), this._renderSponsors()] })] })] }));
    }
    _renderTitle() {
        return _jsx("h2", { children: this.props.model.title });
    }
    _renderPrice() {
        if (this.props.model.type === 'donation') {
            return (_jsx("div", { className: "offer__info__price", children: _jsx(FormattedMessage, Object.assign({}, messages.donation)) }));
        }
        else {
            return (_jsxs("div", { className: "offer__info__price", children: [_jsx("i", { className: "icon-swc-thin" }), _jsx(FormattedNumber, { value: this.props.model.price, maximumFractionDigits: 1 })] }));
        }
    }
    _renderBullets() {
        if (this.props.model.bullets && this.props.model.bullets.length > 0) {
            return (_jsxs("div", { className: "offer__redemption", children: [_jsx("h3", { children: "Bullets" }), _jsx("ul", { children: this.props.model.bullets.map(this._renderBullet.bind(this)) })] }));
        }
        else {
            return null;
        }
    }
    _renderInstruction(model, index) {
        return (_jsx("li", { children: _jsx(SimpleText, { content: model }) }, `instruction-${index}`));
    }
    _renderBullet(model, index) {
        return (_jsx("li", { children: _jsx(SimpleText, { content: model.title + ': ' + model.body }) }, `instruction-${index}`));
    }
    _renderBrand() {
        if (this.props.model.brand) {
            return (_jsxs("div", { className: "offer__brand", children: [_jsx("h3", { children: "Brand" }), _jsx(Sponsor, { content: this.props.model.brand })] }));
        }
        else {
            return null;
        }
    }
    _renderCharity() {
        if (this.props.model.charity) {
            return (_jsxs("div", { className: "offer__brand", children: [_jsx("h3", { children: "Charity" }), _jsx(Sponsor, { content: this.props.model.charity })] }));
        }
        else {
            return null;
        }
    }
    _renderSponsors() {
        if (this.props.model.sponsors && this.props.model.sponsors.length > 0) {
            return (_jsxs("div", { className: "offer__sponsors", children: [_jsx("h3", { children: "Sponsors" }), _jsx("div", { children: this.props.model.sponsors.map(this._renderSponsor.bind(this)) })] }));
        }
        else {
            return null;
        }
    }
    _renderSponsor(model, index) {
        return _jsx(Sponsor, { content: model }, `sponsor-${index}`);
    }
}
export default connect(mapStateToProps)(Offer);
